var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0f64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,17.2c-4.76766,0 -8.85191,2.90522 -10.58203,7.04349l-62.22682,107.32084v0.0112c-1.12304,1.80909 -1.72017,3.89516 -1.72448,6.02448c0,6.33287 5.1338,11.46667 11.46667,11.46667c0.26906,-0.00173 0.53798,-0.01294 0.80625,-0.03359l0.0224,0.03359h62.23802h62.23802l0.02239,-0.04479c0.26814,0.02439 0.53706,0.03933 0.80625,0.04479c6.33287,0 11.46667,-5.1338 11.46667,-11.46667c-0.00223,-2.13313 -0.59944,-4.22335 -1.72448,-6.03567l-0.08958,-0.15677c-0.00373,-0.00373 -0.00746,-0.00747 -0.0112,-0.0112l-62.12604,-107.15287c-1.73013,-4.13827 -5.81437,-7.04349 -10.58203,-7.04349zM79.04609,65.12708h13.90782l-1.15339,37.10989h-11.60104zM86.02239,113.58047c4.7128,0 7.5362,2.53566 7.5362,6.86432c0,4.2484 -2.8234,6.77474 -7.5362,6.77474c-4.7472,0 -7.59218,-2.52634 -7.59218,-6.77474c0,-4.32866 2.83925,-6.86432 7.59218,-6.86432z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a65755c8a0e05b7c5c0b321fb728a7a2.svg";
export { ForwardRef as ReactComponent };